import React from 'react';
import BlogThreeItem from './BlogThreeItem';
import blogThreeData from './blogThreeData';

function Blog3({ productsData }) {
    return (
        <section className="blog-wrapper section-padding">
            <div className="container">
                <div className="row">
                    <div className="col-md-12 col-12 mb-20">
                        <div className="section-title-3">
                            <p>Products</p>
                            <h1>Our Offerings</h1>
                        </div>
                    </div>
                </div>
                <div className="row">
                    {productsData.map((data) => (
                        <BlogThreeItem
                            key={data.id}
                            thumb={data.thumbnail}
                            title={data.title}
                            author={data.author}
                            // meta={data.meta}
                            postLink={data.link}
                            category={data.category}
                            slug={data.slug}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
}

export default Blog3;
